__turbopack_context__.v({
  "iconWrapper": "Icon-module-scss-module__SpM10q__iconWrapper",
});
